import { connect } from 'react-redux';

import {
  checkCoupon,
  checkEmailExists,
  loadAllPublicRates,
  loadPlans,
  loadQualsData,
  loadReferences,
  makeSubscription,
  setCheckEmailExistsMessage,
  setCoupon,
  setSubscriptionMessage,
  setSubscriptionWaiting,
} from '../../actions/signUpActions';
import {
  getChaptersCount,
  getChaptersPmkCount,
  getChaptersPmkWithoutQuestions,
  getChaptersWithoutQuestions,
  getCheckEmailExistsMessage,
  getCheckEmailExistsSuccess,
  getCheckEmailExistsWaiting,
  getCoupon,
  getCycle,
  getLoadingReferences,
  getPlans,
  getQuestionsOccupationalCounter,
  getQuestionsPmkCounter,
  getRates,
  getRatingExamQuestions,
  getReferences,
  getReferencesPmk,
  getSubscriptionMessage,
  getSubscriptionSuccess,
  getSubscriptionWaiting,
  getWarfareAndQualificationReference,
} from '../../components/SignUp/SignUpSelectors';
import SignUpView from '../../components/SignUp/SignUpView';

const mapStateToProps = (state, ownProps) => ({
  rates: getRates(state),
  plans: getPlans(state),
  references: getReferences(state),
  referencesPmk: getReferencesPmk(state),
  loadingReferences: getLoadingReferences(state),
  cycle: getCycle(state),
  chaptersWithoutQuestions: getChaptersWithoutQuestions(state),
  chaptersCount: getChaptersCount(state),
  questionsOccupationalCounter: getQuestionsOccupationalCounter(state),
  questionsPmkCounter: getQuestionsPmkCounter(state),
  chaptersPmkCount: getChaptersPmkCount(state),
  chaptersPmkWithoutQuestions: getChaptersPmkWithoutQuestions(state),
  checkEmailExistsWaiting: getCheckEmailExistsWaiting(state),
  checkEmailExistsMessage: getCheckEmailExistsMessage(state),
  checkEmailExistsSuccess: getCheckEmailExistsSuccess(state),
  subscriptionWaiting: getSubscriptionWaiting(state),
  subscriptionSuccess: getSubscriptionSuccess(state),
  subscriptionMessage: getSubscriptionMessage(state),
  ratingExamQuestions: getRatingExamQuestions(state),
  coupon: getCoupon(state),
  contentByWarfareQuals: getWarfareAndQualificationReference(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadAllPublicRates: () => dispatch(loadAllPublicRates()),
  loadReferences: (rateId, rank, dutyState) =>
    dispatch(loadReferences(rateId, rank, dutyState)),
  loadPlans: () => dispatch(loadPlans()),
  checkEmailExists: (email) => dispatch(checkEmailExists(email)),
  checkCoupon: (coupon, planId, isTrialUser) =>
    dispatch(checkCoupon(coupon, planId, isTrialUser)),
  setCheckEmailExistsMessage: (message) =>
    dispatch(setCheckEmailExistsMessage(message)),
  setSubscriptionMessage: (message) =>
    dispatch(setSubscriptionMessage(message)),
  setSubscriptionWaiting: (value) => dispatch(setSubscriptionWaiting(value)),
  makeSubscription: (data) => dispatch(makeSubscription(data)),
  loadQualsData: () => dispatch(loadQualsData()),
  setCoupon: (value) => dispatch(setCoupon(value)),
});

const SignUpContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignUpView);

export default SignUpContainer;
